import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useT } from "@/i18n";
import { Badge3D } from "@/components/Badges";

const COLORS = ["#facc15", "#38bdf8", "#f472b6", "#4ade80", "#a78bfa", "#fb923c"];
const pieces = Array.from({ length: 40 }, (_, i) => ({ x: (i * 37) % 100, d: (i % 7) * 0.12, c: COLORS[i % COLORS.length], r: (i * 53) % 360 }));

const Jumper = ({ src, delay }) => (
  <motion.img src={src} alt="" className="w-28 sm:w-36 drop-shadow-2xl" initial={{ y: 80, opacity: 0 }}
    animate={{ y: [0, -70, 0, -45, 0], rotate: [0, -12, 8, -6, 0], opacity: 1 }}
    transition={{ duration: 1.4, delay, repeat: Infinity, repeatDelay: 0.3 }} />
);

export default function Celebration({ open, onClose, badge }) {
  const { lang } = useT();
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(onClose, badge ? 6000 : 3500);
    return () => clearTimeout(t);
  }, [open, badge, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div className="fixed inset-0 z-50 flex items-center justify-center bg-blue-950/50 backdrop-blur-sm overflow-hidden" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose} data-testid="celebration-overlay">
          {pieces.map((p, i) => (
            <motion.span key={i} className="absolute top-0 w-3 h-4 rounded-sm" style={{ left: `${p.x}%`, background: p.c }}
              initial={{ y: -40, rotate: 0 }} animate={{ y: "105vh", rotate: p.r + 360 }} transition={{ duration: 2.6, delay: p.d, repeat: Infinity }} />
          ))}
          <motion.div className="relative bg-white rounded-[2rem] border-4 border-yellow-300 shadow-2xl px-6 py-8 text-center max-w-md mx-4" initial={{ scale: 0.6 }} animate={{ scale: 1 }} transition={{ type: "spring", stiffness: 200 }}>
            <div className="flex justify-center items-end gap-4 -mt-24">
              <Jumper src="/img/lumi.webp" delay={0} />
              <Jumper src="/img/spark.webp" delay={0.25} />
            </div>
            <h2 className="font-fredoka text-4xl font-bold text-blue-950 mt-2" data-testid="celebration-title">
              {badge ? (lang === "es" ? "¡Nueva insignia!" : "New badge!") : (lang === "es" ? "¡Lo lograste!" : "You did it!")}
            </h2>
            <p className="font-bold text-blue-900/80 mt-1">{lang === "es" ? "Lumi y Spark están muy orgullosos. +10 monedas" : "Lumi and Spark are so proud. +10 coins"}</p>
            {badge && <div className="mt-5 flex justify-center" data-testid="celebration-badge"><Badge3D stat={badge} big /></div>}
            <button type="button" onClick={onClose} className="glossy-btn mt-5 bg-yellow-300 text-blue-950 font-fredoka font-bold text-lg px-8 py-2.5 rounded-full" data-testid="celebration-close-btn">
              {lang === "es" ? "¡Sigamos!" : "Let's go!"}
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
